import { render } from "./ReportMsgForm.vue?vue&type=template&id=0228b21b"
import script from "./ReportMsgForm.vue?vue&type=script&lang=js"
export * from "./ReportMsgForm.vue?vue&type=script&lang=js"

import "./ReportMsgForm.vue?vue&type=style&index=0&id=0228b21b&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__